/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { useState } from "react";
import UsersFileMgmt from "./Users/UsersFileMgmt";
import SyncOptions from "../../../components/Administrations/FileManagements/SyncOptions/SyncOptions";
import RetentionPolicies from "../../../components/Administrations/FileManagements/RetentionPolicies/RetentionPolicies";
import ExternalUsersFileMgmt from "./ExternalServerUser/ExternalUsersFileMgmt";
import DataPolling from "../../../components/Administrations/FileManagements/DataPolling/DataPolling";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs";
import { Badge } from "../../../components/ui/badge";
import { useGetUsersFileMgmtQuery, useGetExternalUsersFileMgmtQuery } from "../../../store/api/admin/adminApiSlice";

const FileManagements: React.FC = () => {
  const { data: usersData = [] } = useGetUsersFileMgmtQuery();
  const { data: externalUsersData = [] } = useGetExternalUsersFileMgmtQuery();

  const tabs = [
    { 
      label: (
        <span className="flex items-center gap-2">
          Users
          <Badge variant="secondary" className="px-1.5 py-0 min-w-5 h-5 flex items-center justify-center text-xs font-normal">
            {usersData.length}
          </Badge>
        </span>
      ), 
      value: "users", 
      component: <UsersFileMgmt /> 
    },
    { label: "File Storage Limits", value: "file-storage-limits", component: <RetentionPolicies /> },
    { label: "Auto-Configuration", value: "auto-configuration", component: <SyncOptions /> },
    { 
      label: (
        <span className="flex items-center gap-2">
          External server users
          <Badge variant="secondary" className="px-1.5 py-0 min-w-5 h-5 flex items-center justify-center text-xs font-normal">
            {externalUsersData.length}
          </Badge>
        </span>
      ), 
      value: "external-server-users", 
      component: <ExternalUsersFileMgmt /> 
    },
    { label: "Data Polling", value: "data-polling", component: <DataPolling /> },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].value);

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab}>
      <div className="pl-4 pr-1 mt-4">
        <div style={{ borderBottom: "1px solid var(--color-border)" }}>
          <TabsList className="inline-flex h-auto gap-0 rounded-none border-0 bg-transparent p-0 text-muted-foreground shrink-0">
            {tabs.map((tab) => (
              <TabsTrigger
                key={tab.value}
                value={tab.value}
                className="rounded-none border-b-2 border-transparent bg-transparent px-4 py-2 text-sm capitalize text-muted-foreground data-[state=active]:border-primary data-[state=active]:text-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none"
              >
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
      </div>
      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="pt-1">
          {tab.component}
        </TabsContent>
      ))}

    </Tabs>
  );
};

export default FileManagements;